if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartDrawer = document.querySelector('cart-drawer');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      if (this.cartDrawer) {
        this.cartDrawer.setActiveElement(document.activeElement);
      }

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';

      const sectionsToRequest = this.cartDrawer
        ? this.cartDrawer.getSectionsToRender().map((section) => section.section)
        : ['cart-icon-bubble'];

      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: sectionsToRequest,
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (typeof window.trackPdpEvent === 'function') {
            const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
            const cents = response.final_price != null ? response.final_price : response.price;
            const price = (Number(cents) || 0) / 100;
            const quantity = response.quantity || 1;
            window.trackPdpEvent('add_to_cart', {
              item_id: String(response.product_id || ''),
              item_name: response.product_title || response.title || '',
              item_variant: response.variant_title || '',
              price: price,
              quantity: quantity,
              value: price * quantity,
              currency: currency,
            });
          }

          if (this.cartDrawer) {
            this.cartDrawer.renderContents(response);
          } else if (response.sections && response.sections['cart-icon-bubble']) {
            const cartIcon = document.getElementById('cart-icon-bubble');
            if (cartIcon) {
              cartIcon.innerHTML = new DOMParser()
                .parseFromString(response.sections['cart-icon-bubble'], 'text/html')
                .querySelector('.shopify-section').innerHTML;
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          const spinner = this.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
